// stores/useTimeSlotsStore.ts
import { create } from 'zustand';
import apiClient from '../services/axiosInterceptor';

export interface TimeSlot {
  id: string;
  timetable_type_id: string;
  period_number: number;
  period_label: string;
  start_time: string; // "HH:MM:SS"
  end_time: string;   // "HH:MM:SS"
  slot_type: string;
  status: 'active' | 'inactive';
}

interface TimeSlotsState {
  timeSlots: TimeSlot[];
  loading: boolean;
  error: string | null;
  fetchTimeSlots: (timetableTypeId: string) => Promise<void>;
}

export const useTimeSlotsStore = create<TimeSlotsState>((set) => ({
  timeSlots: [],
  loading: false,
  error: null,

  fetchTimeSlots: async (timetableTypeId) => {
    if (!timetableTypeId) {
      set({ error: 'Invalid timetable type ID', loading: false });
      return;
    }

    set({ loading: true, error: null });

    try {
      // Default backend behavior: active slots only. A deactivated
      // (soft-deleted) period should simply disappear from the list.
      const response = await apiClient.get(
        `timeslots?timetable_type_id=${timetableTypeId}`
      );

      const { slots } = response.data;

      set({
        timeSlots: Array.isArray(slots) ? slots : [],
        loading: false,
      });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to load time slots';

      set({
        loading: false,
        error: errorMessage,
      });
    }
  },
}));